
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-6c161ef2&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./WelcomePage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./WelcomePage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-6c161ef2!../node_modules/vue-loader/lib/selector?type=template&index=0!./WelcomePage.vue"),
  /* scopeId */
  "data-v-6c161ef2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/WelcomePage.vue
// module id = 301
// module chunks = 2